import React from 'react';
import { Caption } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/summaryRowStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles(styles);

interface ISummaryRowProps {
	label: string;
	value?: React.ReactElement | React.ReactElement[] | string;
	withBorder?: boolean;
	icon?: React.ReactElement | React.ReactElement[];
	className?: string;
}

const SummaryRow = ({ label, value, icon, withBorder = true, className }: ISummaryRowProps) => {
	const classes = useStyles();

	return (
		<div
			className={classNames({
				[classes.summaryRowWrapper]: true,
				[classes.withBorder]: withBorder,
				[className ? className : '']: className,
			})}
		>
			<div>
				<Caption color="disabled-light">{label}</Caption>
			</div>
			<div>
				{icon}
				{typeof value === 'string' ? <Caption>{value}</Caption> : value}
			</div>
		</div>
	);
};

export default SummaryRow;
